import {gql} from 'apollo-angular';

export const GET_ROOKIE_DAY_CONTACT = gql`
  query GetRookieDayContact($code: String!, $verifyCode: String!) {
    rookiedayContact(code: $code, verifyCode: $verifyCode) {
      id
      firstname
      lastname
      email
      phone
      companyName
      eventDates {
        id
        eventDay
      }
    }
  }
`;
